import { useStores } from '@littlebird/sdk';
import { useEffect, useRef, useState } from 'react';

export function useLoadAllProjectPages(open: boolean) {
  const { projects } = useStores();
  const [loadFailed, setLoadFailed] = useState(false);
  const isDraining = useRef(false);

  useEffect(() => {
    if (!open || isDraining.current) return;
    isDraining.current = true;
    setLoadFailed(false);
    projects
      .loadAllPages()
      .catch((error) => {
        console.error('Failed to load projects', error);
        setLoadFailed(true);
      })
      .finally(() => {
        isDraining.current = false;
      });
  }, [open, projects]);

  return loadFailed;
}
